export default "__VITE_ASSET__CTelLiCc__"